import {Entity} from 'app/core/main.entity';
import {CustomDate} from '../core/classes/customDate';
import {ShiftState} from './enums';
import {ShiftItem} from './shiftItem.entity';
import {Transform, Type} from 'class-transformer';
import {Branch} from './branch.entity';
import 'reflect-metadata';

export class ShiftSettings extends Entity {
  minMinutes: number;
  maxMinutes: number;

  @Type(() => CustomDate)
  @Transform(({value}) => value ? new CustomDate(value) : null)
  minDate: CustomDate = null;

  @Type(() => CustomDate)
  @Transform(({value}) => value ? new CustomDate(value) : null)
  maxDate: CustomDate = null;
}
